import { useState, useEffect } from 'react'

export default function ModernToggle({ checked, onChange, loading = false, disabled = false }) {
  const [isPulsing, setIsPulsing] = useState(false)

  const handleClick = () => {
    if (disabled) return

    onChange(!checked)

    // Animation pulse après le changement
    setIsPulsing(true)
    setTimeout(() => setIsPulsing(false), 600)
  }

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`
        relative inline-flex h-8 w-14 items-center rounded-full
        transition-all duration-300 ease-in-out
        focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
        ${checked ? 'bg-primary-500' : 'bg-gray-300'}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:shadow-md'}
        ${isPulsing ? 'animate-pulse-scale' : ''}
      `}
    >
      <span
        className={`
          inline-block h-6 w-6 transform rounded-full bg-white shadow-lg
          transition-all duration-300 ease-in-out
          ${checked ? 'translate-x-7' : 'translate-x-1'}
        `}
      />
    </button>
  )
}
